import { z } from "zod";

export const schema = z.object({
    name: z.string().min(1, "forms.general-validation.name_required"),
    system_name: z.string().min(1, "forms.general-validation.system_name_required"),
    country_id: z.number().nullable().optional(),
    category: z.string().nullable().optional(),
});

export type FormStructureData = z.infer<typeof schema>;
